"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("./constants");

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/** Mint should only be used for the most important
 * elements or actions such as the primary button,
 * current active navigation or current progress step. */
function ThemeColors(_ref) {
  var colors = _ref.colors,
      fullSize = _ref.fullSize;
  var themeColors = colors ? [{
    theme: '',
    colors: colors
  }] : _constants.THEME;
  var className = (0, _utils.getClassNames)('colors', {
    colors_mini: !fullSize
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className
  }, themeColors.map(function (colors) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: colors.theme
    }, /*#__PURE__*/_react.default.createElement("h3", null, colors.theme), /*#__PURE__*/_react.default.createElement("ul", null, colors.colors.map(function (color) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: color,
        className: color
      }, /*#__PURE__*/_react.default.createElement("span", null, color));
    })));
  }));
}

ThemeColors.propTypes = {
  /** Array of color names */
  colors: _propTypes.default.arrayOf(_propTypes.default.string),

  /** @ignore */
  fullSize: _propTypes.default.bool
};
ThemeColors.defaultProps = {
  colors: null,
  fullSize: false
};
var _default = ThemeColors;
exports.default = _default;